import debug from 'debug';
import ComponentStorage from 'Global/Shared/Components/ComponentStorage/ComponentStorage';
import { report as logService } from 'Minetilbud/Shared/Components/LogService/Report';

const log = debug('DetectAdblock');

class DetectAdblock {
	constructor(element) {
		this.element = element;

		this.initialize();
	}

	initialize() {
		this.sessionKey = 'detectadblock';
		this.componentStorage = new ComponentStorage({ componentKey: this.constructor.name });

		const session = this.componentStorage.getItem(this.sessionKey);
		if (session !== null) return;

		this.loadXmlFile();
	}

	loadXmlFile() {
		fetch('/components/forum/domain/scripts/scripts/ads.xml').then(response => {
			log('loadXmlFile() - OK');
			this.componentStorage.setItem(this.sessionKey, 'false');
		}).catch(error => {
			log('loadXmlFile() - ERROR', error);
			logService.ContentBlocker();
			this.componentStorage.setItem(this.sessionKey, 'true');
		});
	}
}

export default DetectAdblock;
